/* unplugin-vue-components disabled */import { render } from "./Fenglang.vue?vue&type=template&id=3e7b38b1&scoped=true"
import script from "./Fenglang.vue?vue&type=script&lang=js"
export * from "./Fenglang.vue?vue&type=script&lang=js"

import "./Fenglang.vue?vue&type=style&index=0&id=3e7b38b1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7b38b1"]])

export default __exports__